import React from "react";
import st from "./index.module.scss";
import { useIsMobile } from "@pepdirect/helpers/useIsMobile";
import HomePageHeroImg from "components/HomePageHeroImg";

type Props = {
  bgImg: string;
  mobileBgImg?: string;
  canImg: string;
  mobileCanImg?: string;
}

const FlavorSlide = (props: Props) => {
  const isMobile = useIsMobile();

  return (
    <section className={st.bg} style={{ backgroundImage: `url(${isMobile ? props.mobileBgImg || props.bgImg : props.bgImg})` }}>
      <div className={st.gradient} />
      <HomePageHeroImg rightIcon={<div className={st.cans} style={{ backgroundImage: `url(${isMobile ? props.mobileCanImg || props.canImg : props.canImg})` }}/> } />
    </section>
  );
};

export default FlavorSlide;
